import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, FormControlLabel, Stack, Switch, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { IMySetting } from 'src/@types/apiResponseTypes';
import { commonApi } from 'src/api';

export default function MySetting() {
  const [saving, setSaving] = useState(false);
  const { control, handleSubmit, reset } = useForm<IMySetting>({
    defaultValues: { slackId: '', slackAlertYn: false },
  });
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const load = async () => {
      const data = await commonApi.getMySetting();
      if (data) reset(data);
    };
    load();
  }, [reset]);

  const onSubmit = handleSubmit(async (values) => {
    try {
      setSaving(true);
      await commonApi.updateMySetting(values);
      enqueueSnackbar('사용자 설정이 저장되었습니다.', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('사용자 설정 저장에 실패했습니다.', { variant: 'error' });
    } finally {
      setSaving(false);
    }
  });

  return (
    <form onSubmit={onSubmit} style={{ width: '100%' }}>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Box display="flex" gap={2} sx={{ width: '100%', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
          <Controller
            name="slackId"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Slack ID"
                size="small"
                fullWidth
                inputProps={{ style: { textOverflow: 'ellipsis' } }}
              />
            )}
          />
          <FormControlLabel
            style={{ flexShrink: 0 }}
            control={
              <Controller
                name="slackAlertYn"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <Switch checked={!!value} onChange={(e) => onChange(e.target.checked)} />
                )}
              />
            }
            label="Slack 알림"
            sx={{ ml: { xs: 0, sm: 1 }, mr: 0 }}
          />
        </Box>
        <Box sx={{ alignSelf: 'flex-end', width: { xs: '100%', sm: 'auto' } }}>
          <LoadingButton variant="contained" loading={saving} type="submit" size="small">
            저장
          </LoadingButton>
        </Box>
      </Stack>
    </form>
  );
}
